export const PLATFORM_DETAILS_SHOW = "PLATFORMS_PORTAL_PLATFORM_SHOW";
export const PLATFORM_DETAILS_UPDATE = "PLATFORMS_PORTAL_PLATFORM_UPDATE";